import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ProviderDetailsContent from "./ProviderDetailsContent";

import { getProviderDataByProviderAndProduct } from "../../../api/fedRamp";
import { GENERIC_ERROR_STRING } from "../../../constants";

/**
 * FedRamp Provider Details Modal
 * @param {Object} props
 * @param {number} props.providerSeq
 * @param {number} props.productSeq
 * @param {function} props.closeModal
 * @returns {Element}
 * @constructor
 */
export default function ProviderDetails({ providerSeq, productSeq, closeModal }) {
  const [providerDetails, setProviderDetails] = useState(/** @type FedRampProviderViewModel*/null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setProviderDetails(null);
    getProviderDataByProviderAndProduct(providerSeq, productSeq).then(({ data }) => {
      setProviderDetails(data);
    }).catch(error => {
      setError(error);
    });
  }, [providerSeq, productSeq]);

  let modalContent;

  if (error) {
    modalContent = <p>{GENERIC_ERROR_STRING}</p>;
  } else if (providerDetails) {
    modalContent = <ProviderDetailsContent providerDetails={providerDetails}/>;
  } else {
    modalContent = <p>Loading Provider Details</p>;
  }

  return (<Dialog open={true} onClose={closeModal}>
    <DialogTitle sx={{ m: 0, p: 2, color: "white", backgroundColor: "#2D5986", padding: "8px 16px" }}>
      Provider Details
    </DialogTitle>
    <IconButton
      aria-label="close"
      onClick={closeModal}
      sx={{
        position: "absolute", right: 0, top: 0, color: "white",
      }}
    >
      <CloseIcon/>
    </IconButton>
    <DialogContent>
      {modalContent}
    </DialogContent>
  </Dialog>);
}

ProviderDetails.propTypes = {
  providerSeq: PropTypes.number.isRequired,
  productSeq: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
};